<template>
<div class="chapter">
<div class="inner_page">
<div class="prelims-page" id="d3ce853440f00-d1e211"><span id="pageii">
<h3 class="books-by-head"><em class="char-italic italic">A Selection of Titles by Phillip DePoy</em></h3>
<h4 class="books-by-subtitle"><em class="char-italic italic">The Fever Devilin Series</em></h4>
<p class="books-by-text">THE DEVIL’S HEARTH</p>
<p class="books-by-text">THE WITCH’S GRAVE</p>
<p class="books-by-text">A MINISTER’S GHOST</p>
<p class="books-by-text">A WIDOW’S CURSE</p>
<p class="books-by-text">THE DRIFTER’S WHEEL</p>
<p class="books-by-text">A CORPSE’S NIGHTMARE</p>
<p class="books-by-text-space-after">DECEMBER’S THORN</p>
<h4 class="books-by-subtitle"><em class="char-italic italic">The Foggy Moskowitz Series</em></h4>
<p class="books-by-text-space-after">COLD FLORIDA *</p>
<h4 class="books-by-subtitle"><em class="char-italic italic">* available from Severn House</em></h4></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780107394_epub_alb.vue?e4e0dbe0